import Alpine from 'alpinejs';
import swipePlugin from "alpinejs-swipe";
import headerScroll from './components/headerscroll';
import darkModeToggle from './components/darkModeToggle';
// import animatedtext from "./composed/gsapfunctions.js";

import animationsComponent from "./components/animationsComponent.js";
import lazyimages from "./components/lazyimages.js";

// Track loaded components to prevent duplicate imports
const loadedComponents = new Set();

// document.addEventListener("DOMContentLoaded", firstLoadInit);

// function genericInit() {
//     animatedtext.init();
// }

// function firstLoadInit() {
//     genericInit();
// }

window.Alpine = Alpine;

// Prevent multiple loads of the same component
function registerComponent(name, component) {
    if (!loadedComponents.has(name)) {
        loadedComponents.add(name);
        Alpine.data(name, component);
    }
}

registerComponent('headerScroll', headerScroll);
registerComponent('darkModeToggle', darkModeToggle);
registerComponent('animationsComponent', animationsComponent);
registerComponent('lazyimages', lazyimages);

Alpine.plugin(swipePlugin);
Alpine.start();